import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const endOfSunday = () => {
  const d = new Date();
  const end = new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(), 23, 59, 59));
  end.setUTCDate(end.getUTCDate() + ((7 - d.getUTCDay()) % 7));
  return end;
};

const pad = (n) => String(n).padStart(2, "0");

export const OfferCountdown = () => {
  const [left, setLeft] = useState(() => endOfSunday() - Date.now());
  useEffect(() => {
    const t = setInterval(() => setLeft(endOfSunday() - Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const s = Math.max(0, Math.floor(left / 1000));
  const parts = [[Math.floor(s / 86400), "d"], [Math.floor((s % 86400) / 3600), "h"], [Math.floor((s % 3600) / 60), "m"], [s % 60, "s"]];
  return (
    <div data-testid="offer-countdown" className="inline-flex items-center gap-3 px-4 py-3 rounded-md bg-[#0F1117] border border-red-500/40">
      <Clock size={16} className="text-red-400 shrink-0" />
      <div>
        <p className="text-[11px] uppercase tracking-wider font-bold text-red-400">Ends Sunday</p>
        <p data-testid="offer-countdown-time" className="font-mono font-bold text-lg leading-tight">
          {parts.map(([v, u], i) => <span key={u}>{i ? " " : ""}{i ? pad(v) : v}<span className="text-gray-500 text-sm">{u}</span></span>)}
        </p>
      </div>
    </div>
  );
};
